import styled from 'styled-components';
import theme from '../theme';

export const HamburgerButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  color: ${theme.colors.text};
  cursor: pointer;
  border-radius: ${theme.radii.sm};
  font-size: 20px;
  flex-shrink: 0;

  &:hover {
    background: ${theme.colors.background};
  }

  ${theme.media.tablet} {
    display: flex;
  }
`;

export const TopBarWrapper = styled.header`
  height: ${theme.layout.topBarHeight};
  background: ${theme.colors.surface};
  border-bottom: 1px solid ${theme.colors.border};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${theme.layout.contentPadding};
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 50;

  ${theme.media.tablet} {
    padding: 0 ${theme.layout.contentPaddingMobile};
  }
`;

export const TopBarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.md};
`;

export const TopBarRight = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};
`;

export const CompanySelector = styled.select`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.small.size};
  font-weight: 500;
  color: ${theme.colors.text};
  background: ${theme.colors.background};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radii.sm};
  padding: 6px 12px;
  padding-right: 28px;
  cursor: pointer;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 14px;
  transition: border-color ${theme.transitions.fast};

  &:focus {
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 2px ${theme.colors.primaryGhost};
  }
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  cursor: default;
`;

export const UserAvatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: ${theme.radii.full};
  background: ${theme.colors.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  font-family: ${theme.typography.fontFamily};
`;

export const UserName = styled.span`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.small.size};
  font-weight: 500;
  color: ${theme.colors.text};

  ${theme.media.mobile} {
    display: none;
  }
`;

export const PageTitle = styled.h1`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.h2.size};
  font-weight: ${theme.typography.h2.weight};
  color: ${theme.colors.text};
  margin: 0;
`;

export const AddButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: ${theme.radii.full};
  border: none;
  background: ${theme.colors.primary};
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background ${theme.transitions.fast};

  &:hover {
    background: ${theme.colors.primaryDark};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: ${theme.spacing.md};
`;

export const ModalBox = styled.div`
  background: ${theme.colors.surface};
  border-radius: ${theme.radii.md};
  box-shadow: ${theme.shadows.lg};
  padding: ${theme.spacing.xl};
  width: 100%;
  max-width: 440px;
  font-family: ${theme.typography.fontFamily};
`;

export const ModalTitle = styled.h2`
  font-size: ${theme.typography.h3.size};
  font-weight: ${theme.typography.h3.weight};
  color: ${theme.colors.text};
  margin: 0 0 ${theme.spacing.sm} 0;
`;

export const ModalInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.body.size};
  border: 1px solid ${theme.colors.border};
  border-radius: ${theme.radii.sm};
  outline: none;
  box-sizing: border-box;
  transition: border-color ${theme.transitions.fast};

  &:focus {
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 2px ${theme.colors.primaryGhost};
  }

  &:disabled {
    opacity: 0.6;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.sm};
  margin-top: ${theme.spacing.lg};
`;

export const ModalButton = styled.button`
  padding: 8px 20px;
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.typography.small.size};
  font-weight: 600;
  border-radius: ${theme.radii.sm};
  cursor: pointer;
  transition: all ${theme.transitions.fast};
  border: 1px solid ${({ $primary }) => $primary ? theme.colors.primary : theme.colors.border};
  background: ${({ $primary }) => $primary ? theme.colors.primary : theme.colors.surface};
  color: ${({ $primary }) => $primary ? '#ffffff' : theme.colors.text};

  &:hover:not(:disabled) {
    background: ${({ $primary }) => $primary ? theme.colors.primaryDark : theme.colors.background};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
